import React from 'react';
import PropTypes from 'prop-types';
import GenericGuideModal from 'chameleon/ui-stack/ui/modals/guide-modal';
import { COURSE_GUIDE_LABEL } from 'chameleon-src/components/SidebarWrapperTwoLevels/constants';
import './styles.scss';

const getTableContent = (searchTypeText) => [
  {
    title: searchTypeText,
    description: 'Use these search tips',
  },
  {
    title: 'by keyword(s)',
    description: 'Use quotes: {highlightedText}',
    highlightedText: '"Skill 1.A"',
  },
  {
    title: 'with all the words',
    description: 'Type the key words: {highlightedText}',
    highlightedText: 'constitution bill',
  },
  {
    title: 'with an exact phrase',
    description: 'Put exact words in quotes: {highlightedText}',
    highlightedText: '"bill of rights"',
  },
  {
    title: 'with any of the words',
    description: 'Type OR between all the words: {highlightedText}',
    highlightedText: 'constitution OR "bill of rights"',
  },
  {
    title: 'with none of the words',
    description:
      'Put a minus sign with no space just before each word or phrase to exclude: {highlightedText}',
    highlightedText: 'amendments -"bill of rights"',
  },
  {
    title: 'with similar words',
    description:
      'Use an asterisk to find words with the same stem. E.g. Searching ' +
      '{highlightedText} will find {highlightedText} and {highlightedText}',
    highlightedText: ['constitution*', 'constitution', 'constitutional'],
  },
  {
    title: 'combining any of the above',
    description:
      'Use parentheses to group phrases: {highlightedText} will find ' +
      '{highlightedText} or {highlightedText} and also {highlightedText}',
    highlightedText: [
      '(Jefferson OR Hamilton) constitution',
      'Jefferson',
      'Hamilton',
      'constitution',
    ],
  },
];

const GuideModal = (props) => {
  const { outlineSearchInstructionalResourceSearchText, button } = props;
  const searchTypeText = outlineSearchInstructionalResourceSearchText
    ? 'To find resources...'
    : 'To find videos...';
  const tableContent = getTableContent(searchTypeText);

  return (
    <GenericGuideModal
      title={`Refine Your ${COURSE_GUIDE_LABEL} Search`}
      tableContent={tableContent}
      button={button}
      size="big"
    >
      <p className="m-0 text-14 leading-8">
        This will search the instructional resources for your course, which can
        include video captions / transcripts, Progress Checks, Topic Questions,
        and instructional PDF documents.
      </p>
      <p className="m-0 text-14 mt-4.2 leading-8">
        <span className="font-medium">Filter results by resource type.</span>
        &nbsp; Use the resource type tabs.
      </p>
      <p className="m-0 text-14 mt-4.2 leading-8">
        <span className="font-medium">Clear your search.</span>&nbsp; To clear
        your search results, click the "x" in the search box or delete your text
        and press Enter/Return.
      </p>
    </GenericGuideModal>
  );
};

GuideModal.propTypes = {
  outlineSearchInstructionalResourceSearchText: PropTypes.bool,
};

GuideModal.defaultProps = {
  outlineSearchInstructionalResourceSearchText: false,
};

export default GuideModal;
